import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=322ce33c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=322ce33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ce33c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322ce33c')) {
      api.createRecord('322ce33c', component.options)
    } else {
      api.reload('322ce33c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=322ce33c&scoped=true&", function () {
      api.rerender('322ce33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cBWHOjJlv8n0/JS/comp/SearchFilterTokens.vue"
export default component.exports